<div class="tile">
  <span class="tile__title">{{ label }}</span>
  <div class="tile__valueContainer">
    <span class="tile__valueContainer--value">{{ value }}</span>
    <span class="tile__valueContainer--unit">{{ unit | formatUnitId }}</span>
  </div>
</div>
